import React, { useEffect, useState } from "react";
import "./WishlistPage.css";
import {  Row } from "react-bootstrap";
import { connect } from "react-redux";
import NodatafoundPage from "../../../nodatafound/components/NodatafoundPage";
import no_wishlist from "./../../../../assets/no_wishlist.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getRequestcall } from "../../../comman/util/getRequest";
import {
  UN_BOOKMARK,
  BOOKMARK_LIST,
  WISH_LIST,
  WISH_REMOVE,
} from "../../../constants/apiurl";
import { postRequestcall } from "../../../comman/util/postRequest";
import PaginationPage from "../../../comman/components/PaginationPage";
import { Product } from "../../../comman/components/ProductCommonPage";

function WishlistPage(props) {
  const { t } = useTranslation();
  const [wishlistList, setwishlistList] = useState({});
  const [nodata, setNodata] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => callGetwishlist())();
    // eslint-disable-next-line
  }, [props?.detailTab]);

  const callGetwishlist = async () => {
    if (props.detailTab === "store") {
      setwishlistList({
        data: [],
        links: [],
      });
      await callStorewish(1);
    } else if (props.detailTab === "products") {
      setwishlistList({
        data: [],
        links: [],
      });
      callProductwish(1);
    }
  };

  const callStorewish = async (page) => {
    let geturl = BOOKMARK_LIST + `?type=${props?.detailTab}&page=${page}`;
    let responceWishlist = await getRequestcall(geturl, props?.access_token);
    if (responceWishlist?.status === 200) {
      let resultWishlist = await responceWishlist.json();
      if (resultWishlist?.data?.data?.length === 0) {
        setNodata(true);
        setwishlistList({
          data: [],
          links: [],
        });
      } else {
        setwishlistList(resultWishlist?.data);
        setNodata(false);
      }
    } else if (responceWishlist.status === 401) {
      navigate("/", { state: { autologout: true } });
    }
  };

  const callProductwish = async (page) => {
    let geturl = WISH_LIST + `?page=${page}`;
    let getProductwish = await getRequestcall(geturl, props?.access_token);
    if (getProductwish?.status === 200) {
      let resultWishlist = await getProductwish.json();
      if (resultWishlist?.data?.wish_list?.data?.length === 0) {
        setNodata(true);
        setwishlistList({
          data: [],
          links: [],
        });
      } else {
        setwishlistList(resultWishlist?.data?.wish_list);
        setNodata(false);
      }
    }
  };

  const changeCurrentPage = async (pages) => {
    if (props.detailTab === "store") {
      callStorewish(pages);
    } else {
      //for product list
      callProductwish(pages);
    }
  };

  const callunbookmark = async (e, item) => {
    e.stopPropagation();
    e.preventDefault();
    if (props.detailTab === "products") {
      let geturl = WISH_REMOVE + `?id=${item?.product_list?.bookmark_id}`;
      let getResponse = await postRequestcall(geturl, props?.access_token);
      if (getResponse?.status === 200) {
        callProductwish();
      }
    } else {
      let responceBook = await getRequestcall(
        UN_BOOKMARK + `/${item.bookmark_id}`,
        props?.access_token
      );
      if (responceBook?.status === 200) {
        await responceBook?.json();
        callStorewish();
      }
    }
  };

  const navigateDetail = (item) => {
    if (props.detailTab === "products") {
      var timestamp = new Date().getTime();
      navigate(`/product-detail/${item?.product_list?.pid}`, {
        state: {
          categoryId: "",
          refresh: timestamp,
        },
      });
    } else {
      navigate(`/detail/${item?.bookmark}`);
    }
  };

  if (nodata) {
    return (
      <NodatafoundPage
        className={"user-reviews-centent"}
        image={no_wishlist}
        button={t("pages.wishlist.backtodashboard")}
        title={t("pages.wishlist.nowish")}
        description={t("pages.wishlist.nowish_description")}
        navigation={"/user/dashboard"}
      />
    );
  }

  return (
    <>
      <div className="wishlist-centent mt-4">
        <Row className="mt-2 mb-3 wish-list Comman_product">
          {wishlistList?.data?.map((item, index) => (
            <div
              key={index.toString()}
              className="col-6 p-2"
              onClick={() => navigateDetail(item)}
            >
              <Product
                item={{...item?.product_list,...item, variations:[item?.variation_list]}}
                index={index}
                is_productlist={true}
                className={"innerProduct"} //Comman_product
                is_wishlist={true}
                innerClass={props?.detailTab === "products" ? "innerProduct is_productlist  products":"innerProduct is_productlist  store"}
                addorremoveWish={callunbookmark}
                listType={"wishlist"}
                detailTab={props?.detailTab}
              />
            </div>
          ))}
        </Row>
      </div>
      <div className="text-end">
        {!nodata && wishlistList?.total > 10 && (
          <PaginationPage
            changeCurrentpage={changeCurrentPage}
            nopagination={nodata}
            links={wishlistList?.links}
          />
        )}
      </div>
    </>
  );
}
const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  logindata: state?.login?.logindata,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps)(WishlistPage);
